/* SmartLife Ratgeber - Widget-Dock.

   Zwei gleich gestaltete Kacheln:
   - Nach-oben-Taste: unterhalb der Seitenmitte erst zur Mitte, dann zum Hero.
   - ZipChat: liegt in einem offenen Shadow-Root. Der Original-Button wird
     unsichtbar gemacht und deckungsgleich ueber die Kachel gelegt, das
     sichtbare Symbol ist also immer unseres. */

(function () {
  'use strict';

  var ZIPCHAT_HOST_ID = 'zipchat-shadow-host';
  var ZIPCHAT_STYLE_ID = 'slr-zipchat-dock-style';
  var WATCH_INTERVAL = 250;
  var WATCH_TIMEOUT = 30000;

  var ZIPCHAT_CSS = [
    '#widget-chat-container{',
    'position:fixed!important;',
    'right:var(--slr-zip-right,26px)!important;',
    'bottom:var(--slr-zip-bottom,38px)!important;',
    'left:auto!important;top:auto!important;',
    'width:var(--slr-zip-size,72px)!important;',
    'height:var(--slr-zip-size,72px)!important;',
    'overflow:visible!important;',
    'z-index:2147483645!important;',
    'transform:none!important;}',
    '#widget-chat-button{',
    'position:absolute!important;inset:0!important;',
    'width:100%!important;height:100%!important;',
    'opacity:.001!important;',
    'pointer-events:auto!important;',
    'transform:none!important;}'
  ].join('');

  function setupScrollUp(button) {
    if (!button) return;

    var stage = 0;

    function resetStage() {
      stage = 0;
    }

    window.addEventListener('wheel', resetStage, { passive: true });
    window.addEventListener('touchstart', resetStage, { passive: true });

    button.addEventListener('click', function () {
      var root = document.documentElement;
      var maxScroll = Math.max(0, root.scrollHeight - window.innerHeight);
      var midpoint = Math.round(maxScroll / 2);
      var current = window.scrollY || root.scrollTop || 0;
      var target = 0;

      /* Unterhalb der Seitenmitte zuerst zur Mitte, erst danach zum Hero. */
      if (stage === 0 && current > midpoint + 40) {
        target = midpoint;
        stage = 1;
      } else {
        stage = 0;
      }

      window.scrollTo({ top: target, left: 0, behavior: 'smooth' });

      if (typeof window.slLoadDeferredAnalytics === 'function') {
        window.slLoadDeferredAnalytics('seitenhilfe_scroll_up');
      }
    });
  }

  function syncZipChatPosition(slot) {
    if (!slot) return;

    var rect = slot.getBoundingClientRect();

    if (!rect.width || !rect.height) return;

    var root = document.documentElement;

    /* Custom Properties vererben sich in den Shadow-Root hinein. */
    root.style.setProperty('--slr-zip-right', Math.round(document.documentElement.clientWidth - rect.right) + 'px');
    root.style.setProperty('--slr-zip-bottom', Math.round(window.innerHeight - rect.bottom) + 'px');
    root.style.setProperty('--slr-zip-size', Math.round(rect.width) + 'px');
  }

  function setupZipChat(slot) {
    var host = document.getElementById(ZIPCHAT_HOST_ID);
    var shadowRoot = host ? host.shadowRoot : null;
    var chatButton = shadowRoot ? shadowRoot.querySelector('#widget-chat-button') : null;

    if (!slot || !shadowRoot || !chatButton) return false;
    if (slot.classList.contains('is-connected')) return true;

    if (!shadowRoot.querySelector('#' + ZIPCHAT_STYLE_ID)) {
      var style = document.createElement('style');
      style.id = ZIPCHAT_STYLE_ID;
      style.textContent = ZIPCHAT_CSS;
      shadowRoot.appendChild(style);
    }

    syncZipChatPosition(slot);

    window.addEventListener('resize', function () {
      syncZipChatPosition(slot);
    }, { passive: true });

    slot.classList.add('is-connected');

    return true;
  }

  function initSlrWidgetDock() {
    var dock = document.getElementById('slrWidgetDock');

    if (!dock || dock.dataset.slrInitialized === 'true') return;

    dock.dataset.slrInitialized = 'true';

    var zipChatSlot = document.getElementById('slrZipChatWidgetSlot');

    setupScrollUp(document.getElementById('slrScrollUp'));

    var observer = null;
    var watchTimer = null;

    function stopWatching() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      if (watchTimer) {
        window.clearInterval(watchTimer);
        watchTimer = null;
      }
    }

    function connectWidgets() {
      if (setupZipChat(zipChatSlot)) stopWatching();
    }

    /* ZipChat wird asynchron und ausserhalb des normalen DOM nachgeladen
       (Shadow-Root), deshalb Observer und Intervall parallel. */
    observer = new MutationObserver(connectWidgets);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    watchTimer = window.setInterval(connectWidgets, WATCH_INTERVAL);

    window.setTimeout(stopWatching, WATCH_TIMEOUT);

    connectWidgets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlrWidgetDock, { once: true });
  } else {
    initSlrWidgetDock();
  }
})();
